import { BsAspectRatio } from "react-icons/bs";
import { locationFilter } from "../base";
import customOfferBoxItem from "../objects/customOfferBoxItem";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Custom Offer Box",
  name: "customOfferBox",
  type: "object",
  icon: BsAspectRatio,
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    },
    {
      name: "subtitle",
      title: "Subtitle",
      type: "multilingualArrayString"
    },
    {
      name: "items",
      title: "Items",
      type: "array",
      of: [{ type: customOfferBoxItem.name }]
    },
    {
      name: "disclaimer",
      type: "multilingualArrayBlockContent",
      title: "Disclaimer"
    },
    {
      name: "locationFilters",
      title: "Location Filters",
      type: "array",
      of: [
        {
          type: locationFilter.name
        }
      ]
    }
  ],
  preview: {
    select: {
      title: "title",
      subtitle: "subtitle"
    },
    prepare(selection) {
      const { title, subtitle } = selection;
      return {
        title: multilingualStringPreview(title) || "(Custom Offer Box)",
        subtitle: multilingualStringPreview(subtitle)
      };
    }
  }
});
